/* import __COLOCATED_TEMPLATE__ from './posting-create-direct-actions.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
 * This is the component that will manage the show/hide states of the action button in the direct freelancer hire flow
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-posting-create-direct-actions'],
  classNameBindings: [
    '_isHideActions:hide'
  ],

  /**
   * Register services
   */
  errorTracker: service('error-tracker'),
  state: service('states/routes/posting-create'),
  stateManager: service('state-managers/routes/posting-create'),
  session: service(),

  currentUser: readOnly('session.currentUser'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {String}     Text for the action button.
   */
  _actionButtonText: computed(
  'state.updatedDirectIsReadyToMakeOffer',
  'state.updatedDirectIsWorkComplete',
  function() {
    if (this.get('state.updatedDirectIsWorkComplete') && this.get('state.updatedDirectIsReadyToMakeOffer')) {
      return 'Submit Project';
    }

    return 'Start Project';
  }),

  /**
   * @type {Boolean}    True when the form elements should be disabled
   */
  _areFormElementsDisabled: computed(
  'state.isCreatePostingRequestInFlight',
  'state.updatedTitle',
  'state.updatedSelectedServices.length',
  'state.updatedPlaceId',
  'state.updatedDirectFreelancerMessage',
  'state.isReadyToMakeOfferSelected',
  'state.updatedDirectOfferAmount',
  'state.updatedCoverExpenses',
  'state.updatedDirectIsReadyToMakeOffer',
  'state.updatedDirectIsWorkComplete',
  'state.updatedDirectReviewStarCount',
  function() {
    if (this.get('state.isCreatePostingRequestInFlight')) {
      return true;
    }

    return false;
  }),

  /**
   * @type {Boolean}    Will return true when we do NOT want to show this component.
   */
  _isHideActions: computed(
  'state.isWorkCompleteSelected',
  'state.isReadyToMakeOfferSelected',
  'state.updatedDirectIsReadyToMakeOffer',
  function() {
    let isWorkCompleteSelected = this.get('state.isWorkCompleteSelected'),
      isReadyToMakeOfferSelected = this.get('state.isReadyToMakeOfferSelected'),
      isReadyToMakeOfferResponse = this.get('state.updatedDirectIsReadyToMakeOffer');

    if (!isReadyToMakeOfferSelected && !isWorkCompleteSelected) {
      return true;
    }

    if (isReadyToMakeOfferResponse && !isWorkCompleteSelected) {
      return true;
    }

    return false;
  }),

  /**
   * @type {Boolean}
   */
  _isSubmitButtonDisabled: computed(
  '_areFormElementsDisabled',
  'currentUser.company.doesRequireCostCodes',
  'state.updatedDirectIsWorkComplete',
  'state.isReadyToMakeOfferSelected',
  'state.updatedDirectCostCode',
  function() {
    if (this.get('_areFormElementsDisabled')) {
      // if the form elements are disabled, that will be first in order.
      return true;
    }

    if (!this.get('state.updatedDirectIsWorkComplete') || !this.get('state.isReadyToMakeOfferSelected')) {
      return this.get('_areFormElementsDisabled');
    }

    // at this point we have work complete AND we have made an offer.

    // we have to have a cost code, but we don't, always return false.
    if (this.get('currentUser.company.doesRequireCostCodes') && !this.get('state.updatedDirectCostCode')) {
      return true;
    }

    // defer to if the form elements are disabled.
    return this.get('_areFormElementsDisabled');
  }),

  actions: {
    /**
     * When the user clicks the button to create the assignment.
     */
    onConfirmBeginProject: function() {
      this.get('stateManager').createDirectHireAssignment();
    }
  }
});
